<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin sản phẩm
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Cơ sở:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.tenCoSo}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.nhomSp">
                    <v-list-item-content class="font-weight-medium">Nhóm sản phẩm:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.nhomSp.tenNhomSp}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Địa chỉ:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.diaChi}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Liên hệ:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.lienHe}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Xếp hạng:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.xepHang}} sao
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="5"
              >
                <v-img
                  v-if="item.logoBase64"
                  contain
                  width="250"
                  :src="item.logoBase64"
                  class="mx-auto"
                />
                <v-img
                  v-else
                  contain
                  src="@/assets/ocop-logo.png"
                  class="mx-auto"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold justify-left">
                Mô tả sản phẩm
              </v-card-title>
              <v-card-text>
                <div 
                  v-if="item.noiDung"
                  id="post_content" 
                  v-html="item.noiDung"
                />
                <span v-else>
                  Không tìm thấy dữ liệu
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat height="100%">
          <v-card flat class="text-center">
            <v-card-text>
              <span class="text-h6">
                Sản phẩm OCOP khác
              </span>
            </v-card-text>
          </v-card>
          <v-card flat v-for="(relatedItem, index) in relatedItems" 
            :key="index"
            :to="{ name: 'OcopProductTrace', params: { id: relatedItem.id }}"
            class="px-6"
          >
            <div class="d-flex flex-no-wrap">
              <v-avatar
                class="ma-3 rounded-lg"
                size="100"
                tile
              >
                <v-img
                  v-if="relatedItem.logoBase64"
                  :src="relatedItem.logoBase64"
                  contain
                />
                <v-img
                  v-else
                  src="@/assets/ocop-logo.png"
                  contain
                />
              </v-avatar>
              <div>
                <v-card-title class="text-h6">
                  {{relatedItem.tenSanPham}}
                </v-card-title>
                <v-card-subtitle>
                  {{relatedItem.tenCoSo}}
                </v-card-subtitle>
                <v-card-subtitle class="py-0">
                  <v-rating
                    :value="relatedItem.xepHang"
                    color="amber"
                    background-color="grey lighten-1"
                    dense
                    half-increments
                    readonly
                    size="20"
                  />
                </v-card-subtitle>
              </div>
            </div>
          </v-card> 
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapActions } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      item: {},
      relatedItems: []
    }),
    watch: {
      "$route.params.id": function() {
        this.initialize();
      }
    },
    mounted() {
      this.initialize();
      SystemSevice.setSiteViewLocal({
        name: `OcopProductTrace@${this.$route.params.id}`,
      });
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      initialize(){
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/get-ocop-product-detail/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.crumbs = [
              {
                text: 'Sản phẩm Ocop',
                disabled: false,
                href: '/products/ocop',
              },
              {
                text: app.item.tenSanPham,
                disabled: true
              }
            ];
            app.getRelatedItems();
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getRelatedItems(){
        axios.get(`api/v1/public/related-ocop-product/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>
<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  #post_content .ql-align-justify{
    margin-bottom: 0;
  }
  #post_content .ql-align-center{
    text-align: center;
  }
  #post_content img {
    width: 70%;
  }
</style>